import { Controller } from '@hotwired/stimulus';
import Axios from '../axios';

export default class extends Controller {
	static get targets () {
		return ['select', 'membershipsWrapper'];
	}

	connect() {
		this.currentLanguageCode = document.documentElement.lang.split('-')[0];
		this.selectedPlanIds = [];

		this.selectTargets.forEach(select => {
			select.addEventListener('change', () => {
				this.selectedPlanIds = [];
				this.renderMemberships(select.value);
			});
		});

		this.onChangePlanSelect = this.onChangePlanSelect.bind(this);
		this.element.addEventListener('change-plan:select', this.onChangePlanSelect);
	}

	disconnect() {
		this.element.removeEventListener('change-plan:select', this.onChangePlanSelect);
	}

	onChangePlanSelect(event) {
		const { slot, planId } = event.detail;
		this.selectedPlanIds[slot] = planId;

		const clubId = this.selectTargets.length ? this.selectTargets[0].value : this.element.dataset.clubId;
		this.renderMemberships(clubId);
	}

	async renderMemberships(id) {
		this.membershipsWrapperTargets.forEach(membershipsWrapper => {
			//membershipsWrapper.innerHTML = '';
			membershipsWrapper.classList.add('loading-block');
		});

		let url = `/wp-json/api/clubs/${id}/memberships/render?rest_language=${this.currentLanguageCode}`;

		if (this.element.dataset.pid) {
			url += `&pid=${this.element.dataset.pid}`;
		}

		if (this.element.dataset.source) {
			url += `&source=${this.element.dataset.source}`;
		}

		this.selectedPlanIds.forEach((planId, slot) => {
			if (planId) {
				url += `&planIds[${slot}]=${planId}`;
			}
		});

		const spacesSelect = this.element.querySelector('[data-compare-plans-target="clubSelect"]');
		if (spacesSelect?.value) {
			url += `&spacesClubId=${encodeURIComponent(spacesSelect.value)}`;
		}

		let response = await Axios.get(url);
		response = response.data.data;

		document.querySelectorAll('.popup-flyout-modal').forEach(modal => modal.remove());

		const template = document.createElement('template');
		template.innerHTML = response.html.trim();

		const flyouts = Array.from(template.content.querySelectorAll('.popup-flyout-modal'));
		flyouts.forEach(modal => modal.remove());

		this.membershipsWrapperTargets.forEach(membershipsWrapper => {
			membershipsWrapper.classList.remove('loading-block');
			membershipsWrapper.replaceChildren(template.content.cloneNode(true));
		});

		flyouts.forEach(modal => document.body.appendChild(modal));
	}
}
